export enum TermsRoutes {
  Accept = 'accept',
  Check = 'check',
}
